import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import { bundlesLoaded } from './bundlesSlice';
import { statusSet } from './productionComponentInstancesSlice';
import { truckloadCreated } from './truckloadsSlice';

interface ScheduleGridState {
  readonly checkedRows: readonly string[];
  readonly expandedRows: readonly string[];
  readonly userColumnWidths: TableColumnWidthInfo[] | null;
}

const initialState: ScheduleGridState = {
  checkedRows: [],
  expandedRows: [],
  userColumnWidths: null,
};

const scheduleGridSlice = createSlice({
  name: 'scheduleGrid',
  initialState,
  reducers: {
    expandRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.expandedRows.includes(rowId)) continue;
        state.expandedRows.push(rowId);
      }
    },
    collapseRows: (state, action: PayloadAction<readonly string[]>) => {
      state.expandedRows = state.expandedRows.filter((expandedRow) => !action.payload.includes(expandedRow));
    },
    checkRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.checkedRows.includes(rowId)) continue;
        state.checkedRows.push(rowId);
      }
    },
    uncheckRows: (state, action: PayloadAction<readonly string[]>) => {
      state.checkedRows = state.checkedRows.filter((checkedRow) => !action.payload.includes(checkedRow));
    },
    setUserColumnWidths: (state, action: PayloadAction<TableColumnWidthInfo[]>) => {
      state.userColumnWidths = action.payload;
    },
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(bundlesLoaded, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(statusSet, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(truckloadCreated, (state) => {
      state.checkedRows = [];
    });
  },
});

export const { expandRows, collapseRows, checkRows, uncheckRows, setUserColumnWidths } = scheduleGridSlice.actions;
export const scheduleGrid = scheduleGridSlice.reducer;
